import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { BagNotice } from '@/components/generals/bag-notice'

export const Layout: FC<LayoutProps> = ({ children, navigation = [] }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <Header navigation={navigation} />

            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <Footer navigation={navigation} />

            <BagNotice />
        </div>
    )
}
